<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        class="el-col-hasbottom"
        :lg="8"
        :sm="8"
        :xs="12"
      >
        <div class="label">{{$t('withgold.BonusType')}}</div>
        <el-select
          v-model="sendGoldType"
          clearable
          :placeholder="phFileter('please_choose')"
          class="filter-item"
          style="width: 100%;"
          @change="toQuery"
        >
          <el-option
            v-for="item in sendGoldTypeOptions"
            :key="item.key"
            :label="item.display_name"
            :value="item.key"/>
        </el-select>
      </el-col>
      <el-col
        class="el-col-hasbottom"
        :lg="8"
        :sm="8"
        :xs="12"
      >
        <div class="label">{{$t('state')}}</div>
        <el-select
          v-model="status"
          clearable
          :placeholder="phFileter('please_choose')"
          class="filter-item"
          style="width: 100%"
          @change="toQuery"
        >
          <el-option
            v-for="item in goldStatusComputedOptions"
            :key="item.key"
            :label="item.display_name"
            :value="item.key"/>
        </el-select>
      </el-col>
      <el-col
        class="el-col-hasbottom"
        :lg="8"
        :md="8"
        :sm="8"
        :xs="24"
      >
        <div class="label">{{$t('processing_time')}}</div>
        <!--      -->
        <el-date-picker
          v-if="!realMobile"
          style="width: 100%"
          class=""
          @change="toQuery"
          v-model="date"
          type="daterange"
          align="left"
          value-format="yyyy-MM-dd HH-mm-ss"
          unlink-panels
          :range-separator="phFileter('root.dateTo')"
          :start-placeholder="phFileter('root.startDate')"
          :end-placeholder="phFileter('root.endDate')"
        >
        </el-date-picker>
        <select-date-duration
          class="header-sub-item"
          v-model="date"
        ></select-date-duration>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "queryHeader",
  props: {
  },
  data() {
    return {

      currentMt4Account: '',

      sendGoldType: '',
      sendGoldTypeOptions: [
        {
          display_name: this.$t('credit_amount'),
          key: 1,
        },
        {
          display_name: this.$t('User.commissionBanlance'),
          key: 2,
        },
      ],
      status: '',
      goldStatusOptions: [
        {
          display_name: this.$t('withgold.withgoldOut1'),
          key: 0,
        },
        {
          display_name: this.$t('withgold.statusEnd'),
          key: 1,
        },
        {
          display_name: this.$t('withgold.withgoldOut3'),
          key: 2,
        },
        {
          display_name: this.$t('withgold.statusDuring'),
          key: 3,
        },
        {
          display_name: this.$t('withgold.statusExpired'),
          key: 4,
        },
        {
          display_name: this.$t('withgold.statusFree'),
          key: 5,
        },
        {
          display_name: this.$t('withgold.statusComple'),
          key: 6,
        },
        {
          display_name: this.$t('withgold.statusCancle'),
          key: 7,
        },
        {
          display_name: this.$t('withgold.statusReview'),
          key: 8,
        },
        {
          display_name: this.$t('bonusList.Rejection_of_regularization'),
          key: 9,
        },
        {
          display_name: this.$t('bonusList.Passed_the_regularization'),
          key: 10,
        },
      ],
      date: [], // 时间
    }
  },
  computed: {
    ...mapGetters(['userInfo','realMobile']),
    goldStatusComputedOptions(){
      return this.goldStatusOptions;
    }
  },
  methods: {
    phFileter(data){
      return this.$t(data)
    },
    toQuery(){
      this.$emit('toQuery');
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .el-col-hasbottom {
    margin-bottom: 20px;
  }
}
</style>
